import { Directive, EventEmitter, HostListener, Output } from "@angular/core";

@Directive({
	selector: '[middleclick]'
})
export class MiddleClickDirective {
	@Output('middleclick') middleClick = new EventEmitter<MouseEvent>();
	
	@HostListener('mouseup', ["$event"])
	middleClickEvent(event: MouseEvent) {
		if (event.button === 1) {
			this.middleClick.emit(event);
		}
	}
}